import React, { useState } from 'react';
import { Copy, Check, Wifi } from 'lucide-react';
import { TARJETA } from '../config';

// Tarjeta de pago estilo BBVA. Al tocarla copia los datos al portapapeles y
// avisa que se copiaron.
export default function PaymentCard() {
  const [copiado, setCopiado] = useState(false);

  const copiar = async () => {
    const texto =
      `${TARJETA.banco}\n` +
      `Número: ${TARJETA.numero}\n` +
      `Titular: ${TARJETA.titular}`;
    try {
      await navigator.clipboard.writeText(texto);
    } catch (_) {
      // Fallback para navegadores sin permiso de clipboard.
      const ta = document.createElement('textarea');
      ta.value = texto;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2200);
  };

  return (
    <div className="mt-2 w-full max-w-xs">
      <div className="text-center text-amber-300 text-xs font-bold mb-2">
        ✍️ En el concepto pones tu nombre
      </div>

      <button
        onClick={copiar}
        title="Tocar para copiar los datos"
        className="group relative block w-full text-left rounded-2xl p-4 shadow-xl border border-white/10 overflow-hidden transition-transform active:scale-[0.98]"
        style={{
          background:
            'linear-gradient(135deg, #072146 0%, #043263 45%, #1464a5 100%)',
        }}
      >
        {/* Brillo decorativo */}
        <div
          className="pointer-events-none absolute -top-10 -right-10 w-40 h-40 rounded-full opacity-20"
          style={{ background: 'radial-gradient(circle, #49a5e6 0%, transparent 70%)' }}
        />

        <div className="flex items-center justify-between mb-5">
          <span className="text-white font-extrabold tracking-wide text-lg italic">
            {TARJETA.banco}
          </span>
          <Wifi size={18} className="text-white/70 rotate-90" />
        </div>

        {/* Chip */}
        <div className="w-10 h-7 rounded-md mb-3 bg-gradient-to-br from-yellow-200 to-yellow-400 border border-yellow-500/40" />

        {/* Número impreso */}
        <div className="text-white text-lg sm:text-xl font-mono tracking-[0.15em] mb-4 drop-shadow">
          {TARJETA.numero}
        </div>

        <div className="flex items-end justify-between">
          <div>
            <div className="text-[9px] uppercase tracking-wider text-white/50 mb-0.5">
              Titular
            </div>
            <div className="text-white text-sm font-semibold uppercase tracking-wide">
              {TARJETA.titular}
            </div>
          </div>
          <div className="flex items-center gap-1 text-white/80 text-[11px] font-bold bg-white/10 border border-white/15 rounded-lg px-2 py-1">
            {copiado ? <Check size={13} /> : <Copy size={13} />}
            {copiado ? 'Copiado' : 'Copiar'}
          </div>
        </div>
      </button>

      {copiado && (
        <div className="text-center text-emerald-300 text-xs font-semibold mt-2">
          ✅ ¡Datos copiados! Ya puedes pegarlos en tu app del banco.
        </div>
      )}

      <p className="text-slate-300/90 text-xs leading-relaxed mt-3 bg-slate-900/50 border border-slate-700/50 rounded-xl p-3">
        Una vez hecho el pago, <b>nosotros te contactaremos por este mismo chat</b>{' '}
        para acordar tu imagen. Envíanos aquí tu <b>comprobante de pago</b> para
        verificarlo.
      </p>
    </div>
  );
}
